var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiDetailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4L12 4",
    stroke: "#0F4AA2",
    strokeWidth: 1.14,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6H12",
    stroke: "#0F4AA2",
    strokeWidth: 1.14,
    strokeLinecap: "round",
    strokeDasharray: "2 2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8H11",
    stroke: "#0F4AA2",
    strokeWidth: 1.14,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 10H11",
    stroke: "#0F4AA2",
    strokeWidth: 1.14,
    strokeLinecap: "round",
    strokeDasharray: "1 2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12H8",
    stroke: "#0F4AA2",
    strokeWidth: 1.14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiDetailed);
export default __webpack_public_path__ + "static/media/ai-detailed.8ccac462b04cd914ffe644a59cb98d10.svg";
export { ForwardRef as ReactComponent };